import { useLayoutEffect } from 'react';
import { ConnectionMode, DEFAULT_MAX_ZOOM, DEFAULT_MIN_ZOOM } from '../../core';
import type { DefaultEdgeOptions } from '../../core';
import { useStoreApi } from '../../store';
import type { NodeTypes } from '../../store';
import type { EngineProps } from './CustomMindmap.types';

const NO_NODE_TYPES: NodeTypes = {};
const NO_EDGE_DEFAULTS: DefaultEdgeOptions = {};

/** Copies controlled data props and render options into the store before paint, so the first frame shows them. */
export const useControlledSync = ({
  nodes,
  edges,
  defaultEdgeOptions = NO_EDGE_DEFAULTS,
  minZoom = DEFAULT_MIN_ZOOM,
  maxZoom = DEFAULT_MAX_ZOOM,
  nodeTypes = NO_NODE_TYPES,
  onNodesChange,
  onEdgesChange,
  connectionMode = ConnectionMode.Strict,
}: EngineProps): void => {
  const store = useStoreApi();
  useLayoutEffect(() => {
    if (nodes) store.getState().setNodes(nodes);
  }, [store, nodes]);
  useLayoutEffect(() => {
    if (edges) store.getState().setEdges(edges);
  }, [store, edges]);
  useLayoutEffect(() => {
    store.getState().setDefaultEdgeOptions(defaultEdgeOptions);
  }, [store, defaultEdgeOptions]);
  useLayoutEffect(() => {
    store.getState().setZoomLimits(minZoom, maxZoom);
  }, [store, minZoom, maxZoom]);
  useLayoutEffect(() => {
    store.getState().setNodeTypes(nodeTypes);
  }, [store, nodeTypes]);
  useLayoutEffect(() => {
    store.getState().setOnNodesChange(onNodesChange);
  }, [store, onNodesChange]);
  useLayoutEffect(() => {
    store.getState().setOnEdgesChange(onEdgesChange);
  }, [store, onEdgesChange]);
  useLayoutEffect(() => {
    store.getState().setConnectionMode(connectionMode);
  }, [store, connectionMode]);
};
